/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { BillingInterval } from "./BillingInterval";

export interface BillingIntervalModel {
  interval: BillingInterval;
  /** e.g. 1 = every month, 3 = every 3 months */
  interval_count: number;
}
